const PAYMENT_METHODS_DETAILS_DICT = {
  custom_method: {
    display_name: 'Custom',
    is_custom_method: true,
    reference: {
      should_include: true,
      max_length: 30,
    },
    include_force_mortgagee_option: false,
    are_multiple_payees_supported: false,
  },
  check: {
    display_name: 'Check',
    pay_to_line: {
      should_include: true,
      default_max_length: 120,
    },
    check_description: {
      should_include: true,
      max_length: 60,
    },
    mail_to_contact: {
      should_include: true,
    },
    include_force_mortgagee_option: true,
    are_multiple_payees_supported: true,
  },
  echeck: {
    display_name: 'eCheck',
    pay_to_line: {
      should_include: true,
      default_max_length: 120,
    },
    check_description: {
      should_include: true,
      max_length: 60,
    },
    mail_to_contact: {
      should_include: true,
    },
    always_required_fields: ['email'],
    include_force_mortgagee_option: true,
    are_multiple_payees_supported: true,
  },
  one_inc: {
    display_name: 'One Inc',
    pay_to_line: {
      should_include: true,
    },
    mail_to_contact: {
      should_include: true,
    },
    include_force_mortgagee_option: false,
    are_multiple_payees_supported: true,
    always_enable_documents: true,
    excluded_required_fields: ['phone_number', 'email', 'date_of_birth'],
    always_require_permissions_to_send_communication: true,
    always_move_to_pending_cancel_upon_cancellation: true,
  },
  uk_bank_transfer: {
    display_name: 'UK Bank Transfer',
    contact_bank_fields: {
      uk_sort_code: 'request_extra.uk_bank.uk_sort_code',
      uk_bank_account_number: 'request_extra.uk_bank.uk_bank_account_number',
    },
    accountNumber: {
      should_include: true,
    },
    sortCode: {
      should_include: true,
    },
    reference: {
      should_include: true,
      max_length: 18,
    },
    include_force_mortgagee_option: false,
    are_multiple_payees_supported: false,
  },
  iban_bank_transfer: {
    display_name: 'IBAN',
    contact_bank_fields: {
      iban: 'iban',
      swift_bic: 'swift_bic',
    },
    iban: {
      should_include: true,
    },
    reference: {
      should_include: true,
      max_length: 30,
    },
    swift_bic: {
      should_include: true,
      optional: true,
    },
    include_force_mortgagee_option: false,
    are_multiple_payees_supported: false,
  },
  commerce_bank: {
    display_name: 'Commerce Bank',
    pay_to_line: {
      should_include: true,
    },
    mail_to_contact: {
      should_include: true,
    },
    include_force_mortgagee_option: false,
    are_multiple_payees_supported: true,
    always_enable_documents: true,
    is_legacy_method: true,
    always_move_to_pending_cancel_upon_cancellation: true,
  },
  au_bank_transfer: {
    display_name: 'AU Bank Transfer',
    contact_bank_fields: {
      au_bsb_number: 'au_bank.au_bsb_number',
      au_bank_account_number: 'au_bank.au_bank_account_number',
      swift_bic: 'swift_bic',
    },
    accountNumber: {
      should_include: true,
    },
    bsbNumber: {
      should_include: true,
    },
    reference: {
      should_include: true,
    },
    swift_bic: {
      should_include: true,
      optional: true,
    },
    include_force_mortgagee_option: false,
    are_multiple_payees_supported: false,
  },
  nz_bank_transfer: {
    display_name: 'NZ Bank Transfer',
    contact_bank_fields: {
      nz_bank_account_number: 'nz_bank_account_number',
      swift_bic: 'swift_bic',
    },
    accountNumber: {
      should_include: true,
    },
    reference: {
      should_include: true,
    },
    swift_bic: {
      should_include: true,
      optional: true,
    },
    include_force_mortgagee_option: false,
    are_multiple_payees_supported: false,
  },
  us_ach: {
    display_name: 'US ACH',
    accountNumber: {
      should_include: true,
    },
    routingNumber: {
      should_include: true,
    },
    reference: {
      should_include: true,
      max_length: 128,
    },
    include_force_mortgagee_option: false,
    are_multiple_payees_supported: false,
  },
} as const;

export default PAYMENT_METHODS_DETAILS_DICT;
